/**
 * Helper for JavaScript-Links – prevents reload of the same site for links with empty href-attribute
 */

import App from 'libs/app';

App.registerReadyHandler('js-links-href', () => {
    document.body.addEventListener('click', (e) => {
        if (e.target?.getAttribute('href') === '') {
            e.preventDefault();
        }
    });
});
